
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/local/[id]",
      function () {
        return require("private-next-pages/local/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/local/[id]"])
      });
    }
  